"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSelectElement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var react_toastify_1 = require("react-toastify");
var utils_1 = require("../utils");
var ACWrapperContext_1 = require("./ACWrapperContext");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
// import '../styles/select.css';
// Function to filter options based on user input
var filterOptions = function (input, option) {
    var _a;
    return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase());
};
// Custom tag rendering function
var customTagRender = function (props) {
    var label = props.label, closable = props.closable, onClose = props.onClose, color = props.color;
    var onPreventMouseDown = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    return ((0, jsx_runtime_1.jsxs)(antd_1.Tag, { color: color, onMouseDown: onPreventMouseDown, closable: closable, onClose: onClose, style: { marginRight: 3 }, children: [label, " "] }));
};
var customIconTagRender = function (props) {
    var label = props.label, closable = props.closable, onClose = props.onClose, icon = props.icon;
    var onPreventMouseDown = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    return ((0, jsx_runtime_1.jsxs)(antd_1.Tag
    // color={color}
    , { 
        // color={color}
        onMouseDown: onPreventMouseDown, closable: closable, onClose: onClose, className: "bg-primary/5 p-1 px-3 flex items-center gap-1", children: [icon && (0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(icon) }), (0, jsx_runtime_1.jsx)("span", { children: label })] }));
};
var ACSelectElement = function (props) {
    var iconTypeOption = function (option) {
        var _a, _b, _c;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3 my-1", children: [((_a = option === null || option === void 0 ? void 0 : option.data) === null || _a === void 0 ? void 0 : _a.icon) && ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat((_b = option === null || option === void 0 ? void 0 : option.data) === null || _b === void 0 ? void 0 : _b.icon, " ").concat((props === null || props === void 0 ? void 0 : props.optionIconClassName) || '') })), (0, jsx_runtime_1.jsx)("span", { children: (_c = option === null || option === void 0 ? void 0 : option.data) === null || _c === void 0 ? void 0 : _c.label })] }));
    };
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(props.value), selectedValue = _b[0], setSelectedValue = _b[1];
    // console.log('__selectedValue', selectedValue);
    var _c = (0, react_1.useState)(props.options || []), options = _c[0], setOptions = _c[1];
    (0, react_1.useEffect)(function () {
        setSelectedValue(props.value);
    }, [props.value]);
    var debouncedSearch = (0, react_1.useMemo)(function () {
        return utils_1.Utils.debounce(function (text) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_GET_Options({
                            searchText: text,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, 500);
    }, []);
    var handleFocus = function () {
        API_GET_Options({ searchText: '' });
    };
    var handleSearch = function (value) {
        debouncedSearch(value);
    };
    var API_GET_Options = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var _c, endPoint, rootState, _d, functionName, params, endpoint, ParentUtils, func, res, data, error_1;
        var _e = _b.searchText, searchText = _e === void 0 ? '' : _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _c = props.endPoint, endPoint = _c === void 0 ? '' : _c, rootState = props.rootState, _d = props.function, functionName = _d === void 0 ? '' : _d;
                    params = __assign(__assign({}, props.params), { searchText: searchText });
                    if (!endPoint) {
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    return [4 /*yield*/, utils_1.Utils.getProcessedEndpoint({
                            params: params,
                            endPoint: endPoint,
                            rootState: rootState,
                        })];
                case 1:
                    endpoint = _f.sent();
                    ParentUtils = (0, ACWrapperContext_1.getUtils)();
                    func = ParentUtils[functionName] || ParentUtils.makeApiCall;
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 4, 5, 6]);
                    return [4 /*yield*/, func("".concat(endpoint), 'GET')];
                case 3:
                    res = _f.sent();
                    if (!res.status) {
                        react_toastify_1.toast.error(res.message, {
                            position: 'top-center',
                            autoClose: 2000,
                        });
                        return [2 /*return*/];
                    }
                    data = res.data.map(function (option) { return (__assign(__assign({}, option), { label: (option === null || option === void 0 ? void 0 : option.label) || (option === null || option === void 0 ? void 0 : option[(props === null || props === void 0 ? void 0 : props.optionLabelKey) || '']), value: (option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option[(props === null || props === void 0 ? void 0 : props.optionValueKey) || '']) })); });
                    setOptions(__spreadArray([], data, true));
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _f.sent();
                    react_toastify_1.toast.error('Error', {
                        position: 'top-center',
                        autoClose: 2000,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    // Optionally, you can handle any cleanup or final actions here
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (value) {
        var getOptionValue = function (option) { var _a; return (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : (props.optionValueKey && (option === null || option === void 0 ? void 0 : option[props.optionValueKey])); };
        if (props.onChange) {
            if (typeof value === 'string' || typeof value === 'number') {
                var matched = options === null || options === void 0 ? void 0 : options.find(function (opt) { return getOptionValue(opt) === value; });
                props.onChange(matched || { value: value, label: value });
            }
            else if (Array.isArray(value)) {
                var selectedOptions = value.map(function (val) {
                    var fromOptions = options === null || options === void 0 ? void 0 : options.find(function (opt) { return getOptionValue(opt) === val; });
                    var fromProps = Array.isArray(props.value)
                        ? props.value.find(function (opt) { return getOptionValue(opt) === val; })
                        : getOptionValue(props.value) === val
                            ? props.value
                            : null;
                    return fromOptions || fromProps || { value: val, label: val };
                });
                props.onChange(selectedOptions);
            }
        }
        setSelectedValue(value);
    };
    var isValid = props.mode === 'multiple'
        ? Array.isArray(selectedValue)
        : selectedValue && typeof selectedValue === 'object';
    var value = isValid ? selectedValue : null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)(antd_1.ConfigProvider, { theme: {
                    token: {
                        colorBgContainerDisabled: props.disabledColor || '',
                    },
                }, children: (0, jsx_runtime_1.jsx)(antd_1.Select, { options: options || [], placeholder: props.placeholder, allowClear: props.allowClear, notFoundContent: loading ? (0, jsx_runtime_1.jsx)(antd_1.Spin, { size: "small" }) : (0, jsx_runtime_1.jsx)(antd_1.Empty, {}), filterOption: !(props === null || props === void 0 ? void 0 : props.endPoint) && filterOptions, showSearch: true, onSearch: (props === null || props === void 0 ? void 0 : props.endPoint) ? handleSearch : undefined, onFocus: handleFocus, className: "".concat('apx-ui_select', " ").concat((props === null || props === void 0 ? void 0 : props.color) || 'primary', " ").concat(props.className), onChange: handleChange, mode: props.mode, value: value, disabled: props.disabled, status: props.required && props.errorText ? 'error' : '', tokenSeparators: [','], optionRender: (props === null || props === void 0 ? void 0 : props.optionRenderType) === 'iconized' ? iconTypeOption : undefined, tagRender: props.customColor
                        ? function (tagProps) {
                            var foundOption = options === null || options === void 0 ? void 0 : options.find(function (opt) { return opt.value === tagProps.value; });
                            var color = (foundOption === null || foundOption === void 0 ? void 0 : foundOption.color) || 'default';
                            return customTagRender(__assign(__assign({}, tagProps), { label: typeof tagProps.label === 'string' ? tagProps.label : '', color: color }));
                        }
                        : (props === null || props === void 0 ? void 0 : props.optionRenderType) === 'iconized'
                            ? function (tagProps) {
                                var foundOption = options === null || options === void 0 ? void 0 : options.find(function (opt) { return opt.value === tagProps.value; });
                                foundOption = foundOption || (value === null || value === void 0 ? void 0 : value.find(function (opt) { return opt.value === tagProps.value; }));
                                var icon = (foundOption === null || foundOption === void 0 ? void 0 : foundOption.icon) || '';
                                return customIconTagRender(__assign(__assign({}, tagProps), { label: typeof tagProps.label === 'string'
                                        ? tagProps.label
                                        : '', icon: icon }));
                            }
                            : undefined }) }), props.required ? ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText && props.errorText })) : ('')] }));
};
exports.ACSelectElement = ACSelectElement;
